import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizLineChart } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import Volume from "@radarly/shared/widgets/date-metrics/line-chart";
import { CardFragmentProps } from "../model";

const RadarlyMetricCardsLineChart = ({
  title,
  fragment,
  project,
  dataviz,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<SearchFragmentDateMetrics, DatavizLineChart>) => {
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date nowDate={nowDate} fragment={fragment} timezone={timezone} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <Volume
        fragment={fragment}
        project={project.id}
        dataviz={dataviz}
        onClickPoint={onClickItem}
        forceReload={forceReload}
        nowDate={nowDate}
      />
    </Tile>
  );
};

export default RadarlyMetricCardsLineChart;
